import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { Link } from 'react-router-dom';

import LinkView from 'lib/ui/link-view';
import Styled from 'styled';
import Localizable from 'lib/intl/localizable';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';

import VerticalSeparatorView from 'four-nets/ui/vertical-separator-view';
import StarsView from 'four-nets/bazaar/review/stars-view';
import { UserBazaarLink } from 'four-nets/bazaar/user-bazaar/user-bazaar-link';
import { displayedName } from 'four-nets/user/utils';

import defaultStyles from 'four-nets/common/comment/comment-header/comment-header-view.scss';
import verticalSeparatorStyles from 'four-nets/common/comment/comment-header/vertical-separator-view.scss';

export interface Props {
    commentHeaderViewModel: any;
    rating?: number;
    styles: typeof defaultStyles;
}

@Localizable()
@observer
class CommentHeaderView extends React.Component<Props> {
    @computed get bazaarLink() {
        if (this.props.commentHeaderViewModel.comment.user) {
            return new UserBazaarLink({
                user: this.props.commentHeaderViewModel.comment.user,
            });
        }
        return null;
    }

    render() {
        const { commentHeaderViewModel, rating } = this.props;
        const styles = this.props.styles!;

        const { comment, vendorLink } = commentHeaderViewModel;
        const { user } = comment;

        return (
            <div className={styles.commentHeader}>
                <div className={styles.userWrapper}>
                    <div className={styles.linkWrapper}>
                        {!user.isAnonymous ? (
                            <Link to={this.bazaarLink && this.bazaarLink.href} className={styles.user}>
                                {this.bazaarLink && this.bazaarLink.label}
                            </Link>
                        ) : (
                            <p className={styles.user}>{displayedName(user)}</p>
                        )}
                        {rating ? <VerticalSeparatorView styles={verticalSeparatorStyles} /> : null}
                        {vendorLink ? (
                            <div>
                                <LinkView link={vendorLink} className={styles.vendorLink} />
                                {user.dateJoined ? <VerticalSeparatorView styles={verticalSeparatorStyles} /> : null}
                            </div>
                        ) : null}
                    </div>
                    {rating ? (
                        <div className={styles.userInfo}>
                            <StarsView rating={rating} />
                        </div>
                    ) : null}
                </div>
                <div className={styles.date}>{<FormattedDateAgoView value={comment.time} />}</div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(CommentHeaderView);
